import { gColors } from '~/modules/gColors/colors';

const buttonStyles =  {
  'light-grey': {
    textColor: gColors('Gravel').hex,
    backgroundColor: gColors('Mercury').hex,
    borderColor: gColors('Mercury').hex
  },
  'grey': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Boulder').hex,
    borderColor: gColors('Boulder').hex
  },
  'dark-grey': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Charcoal').hex,
    borderColor: gColors('Charcoal').hex
  },
  'red': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Alizarin').hex,
    borderColor: gColors('Alizarin').hex
  },
  'blue': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Mariner').hex,
    borderColor: gColors('Mariner').hex
  },
  'lake': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Lake').hex,
    borderColor: gColors('Lake').hex
  },
  'purple': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Fuchsia').hex,
    borderColor: gColors('Fuchsia').hex
  },
  'dark-purple': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Purple Heart').hex,
    borderColor: gColors('Purple Heart').hex
  },
  'green': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Laurel').hex,
    borderColor: gColors('Laurel').hex
  },
  'dark-green': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Green Pea').hex,
    borderColor: gColors('Green Pea').hex
  },
  'brown': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Golden Brown').hex,
    borderColor: gColors('Golden Brown').hex
  },
  'dark-brown': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Sepia').hex,
    borderColor: gColors('Sepia').hex
  },
  'tan': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Yukon Gold').hex,
    borderColor: gColors('Yukon Gold').hex
  },
  'orange': {
    textColor: gColors('White').hex,
    backgroundColor: gColors('Rust').hex,
    borderColor: gColors('Rust').hex
  },
  'light-grey-outline': {
    textColor: gColors('Gravel').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Mercury').hex,
    backgroundHoverColor: gColors('Mercury').hex,
    textHoverColor: gColors('Gravel').hex
  },
  'grey-outline': {
    textColor: gColors('Boulder').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Boulder').hex,
    backgroundHoverColor: gColors('Boulder').hex,
    textHoverColor: gColors('White').hex
  },
  'dark-grey-outline': {
    textColor: gColors('Charcoal').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Charcoal').hex,
    backgroundHoverColor: gColors('Charcoal').hex,
    textHoverColor: gColors('White').hex
  },
  'red-outline': {
    textColor: gColors('Alizarin').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Alizarin').hex,
    backgroundHoverColor: gColors('Alizarin').hex,
    textHoverColor: gColors('White').hex
  },
  'blue-outline': {
    textColor: gColors('Mariner').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Mariner').hex,
    backgroundHoverColor: gColors('Mariner').hex,
    textHoverColor: gColors('White').hex
  },
  'lake-outline': {
    textColor: gColors('Lake').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Lake').hex,
    backgroundHoverColor: gColors('Lake').hex,
    textHoverColor: gColors('White').hex
  },
  'purple-outline': {
    textColor: gColors('Fuchsia').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Fuchsia').hex,
    backgroundHoverColor: gColors('Fuchsia').hex,
    textHoverColor: gColors('White').hex
  },
  'dark-purple-outline': {
    textColor: gColors('Purple Heart').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Purple Heart').hex,
    backgroundHoverColor: gColors('Purple Heart').hex,
    textHoverColor: gColors('White').hex
  },
  'green-outline': {
    textColor: gColors('Laurel').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Laurel').hex,
    backgroundHoverColor: gColors('Laurel').hex,
    textHoverColor: gColors('White').hex
  },
  'dark-green-outline': {
    textColor: gColors('Green Pea').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Green Pea').hex,
    backgroundHoverColor: gColors('Green Pea').hex,
    textHoverColor: gColors('White').hex
  },
  'brown-outline': {
    textColor: gColors('Golden Brown').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Golden Brown').hex,
    backgroundHoverColor: gColors('Golden Brown').hex,
    textHoverColor: gColors('White').hex
  },
  'dark-brown-outline': {
    textColor: gColors('Sepia').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Sepia').hex,
    backgroundHoverColor: gColors('Sepia').hex,
    textHoverColor: gColors('White').hex
  },
  'tan-outline': {
    textColor: gColors('Yukon Gold').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Yukon Gold').hex,
    backgroundHoverColor: gColors('Yukon Gold').hex,
    textHoverColor: gColors('White').hex
  },
  'orange-outline': {
    textColor: gColors('Rust').hex,
    backgroundColor: 'transparent',
    borderColor: gColors('Rust').hex,
    backgroundHoverColor: gColors('Rust').hex,
    textHoverColor: gColors('White').hex
  },
};

const colorLibrary = {
  'light' : {
    buttonStyles,
    text: gColors('Dove Grey').hex,
    title: gColors('Charcoal').hex,
    link: gColors('Charcoal').hex,
    dynamicElement: gColors('Mariner').hex,
    primaryGreen: gColors('Laurel').hex,
    btn: {
      default: {
        color: gColors('White').hex,
        background: gColors('Boulder').hex,
      },
      hover: {
        background: gColors('Mariner').hex
      }
    },
    line: {
      color: gColors('Silver Chalice').hex
    },
    formElement: {
      default: {
        background: gColors('White').hex,
        border: gColors('Alto').hex
      },
      hover: {
        background: gColors('Floral White').hex
      },
      error: {
        background: '#fef2f1',
        text: gColors('Cinnabar').hex,
        border: gColors('Cinnabar').hex
      }
    },
    startStep: {
      default: {
        background: gColors('Honeydew').hex,
        hover: gColors('Honeydew').darken(2.5).hex,
        text: gColors('Green Pea').hex,
        border: gColors('Green Pea').hex,
      }
    },
    startLoopStep: {
      default: {
        background: gColors('Floral White').hex,
        hover: gColors('Floral White').darken(2.5).hex,
        text: gColors('Woody Brown').hex,
        border: gColors('Buttercup').hex,
      }
    },
    endStep: {
      default: {
        background: gColors('Chablis').hex,
        text: gColors('Thunderbird').hex,
        border: gColors('Alizarin').hex,
      }
    },
    endLoopStep: {
      default: {
        background: gColors('Milk Punch').hex,
        text: gColors('Woody Brown').hex,
        border: gColors('Buttercup').hex,
      }
    },
  },
  'dark' : {
    buttonStyles,
    text: gColors('Seal').hex,
    title: gColors('Silver').hex,
    link: gColors('Silver').hex,
    dynamicElement: gColors('Mariner').hex,
    primaryGreen: gColors('Laurel').hex,
    btn: {
      default: {
        color: gColors('White').hex,
        background: gColors('Dove Grey').hex,
      },
      hover: {
        background: gColors('Sandal').hex
      }
    },
    line: {
      color: gColors('Seal').hex
    },
    formElement: {
      default: {
        background: gColors('Mine Shaft').hex,
        border: gColors('Seal').hex
      },
      hover: {
        background: gColors('Night Rider').hex
      },
      error: {
        background: '#fef2f1',
        text: gColors('Cinnabar').hex,
        border: gColors('Cinnabar').hex
      }
    },
    startStep: {
      default: {
        background: gColors('Honeydew').hex,
        text: gColors('Green Pea').hex,
        hover: gColors('Honeydew').darken(2.5).hex,
        border: gColors('Green Pea').hex,
      }
    },
    startLoopStep: {
      default: {
        background: gColors('Night Rider').hex,
        text: gColors('Woody Brown').hex,
        border: gColors('Buttercup').hex,
      }
    },
    endStep: {
      default: {
        background: gColors('Chablis').hex,
        text: gColors('Thunderbird').hex,
        border: gColors('Alizarin').hex,
      }
    },
    endLoopStep: {
      default: {
        background: gColors('Milk Punch').hex,
        text: gColors('Woody Brown').hex,
        border: gColors('Buttercup').hex,
      }
    },
  },
};

export { colorLibrary };
